export default __webpack_public_path__ + "static/hero-65d53e0064ba961df6893405fe7afafa.mp4";